import { ComponentType, FC } from 'react';

import { Permissions } from 'utils/constants/permissions';

// @ts-expect-error: allow import any type
import PrivateRoute from 'app/routes/PrivateRoute';

const getUrlRedirect = (permissions: Permissions[]) => {
    if (permissions.includes(Permissions.ViewPersonalAreaSection)) {
        window.location.href = '/new/not-found/';
        return '';
    }
    if (permissions.includes(Permissions.PermissionDenied)) {
        return '/new/forbidden/';
    }
    if (permissions.includes(Permissions.UserNotAuthorized)) {
        return '/new/login/';
    }
    return '/new/';
};

const ModeratorRoute: FC<{ component: ComponentType }> = ({ component, ...props }) => (
    <PrivateRoute
        component={component}
        urlByPermissions={getUrlRedirect}
        allowingPermission={Permissions.ViewModeration}
        {...props}
    />
);

export { ModeratorRoute };
